import type {Ref} from 'vue';
import {onMounted} from 'vue';

export const useComponentTracking = (rootContainer: Ref<HTMLElement | null>) => {
    function addComponentTrackingParam(anchor: HTMLAnchorElement) {
        if (!anchor) {
            return;
        }

        const {href} = anchor;
        const {componentSource} = anchor.dataset;

        if (href && componentSource) {
            const [baseHref, hash] = href.split('#');
            const separator = href.includes('?') ? '&' : '?';
            const hashParam = href.includes('#') ? `#${hash}` : '';
            const newHref = `${baseHref}${separator}componentSource=${componentSource}${hashParam}`;
            anchor.setAttribute('href', newHref);
        }
    }

    onMounted(() => {
        if (!rootContainer.value) {
            return;
        }
        const anchors: HTMLAnchorElement[] = Array.from(rootContainer.value.querySelectorAll('a[data-component-source]'));
        anchors.forEach(addComponentTrackingParam);
    });
};
